import { DebuggingChannel } from "@app/channels/test/debugging_channel";

window.ChannelManager = new class ChannelManager {
  constructor(){
    this.activeChannels = {};
    this.callbacks      = {};
    this.options        = {
      triggerTimer: 0,
      triggerDelay: 500,
    };
    this.channelsIsLoaded = false;
    this.DebuggingChannel = DebuggingChannel;

    this.subscriptions  = [];
  }

  on(event, callback) {
    this.callbacks[event] ||= [];
    this.callbacks[event].push(callback);
  }

  channelsLoaded(){
    console.log(
      `%cWebsocket\n%cAll channels %care connected ...`,
      "font-weight:bold;color:white;",
      "color:orange;",
      "color:gray;",
    );

    if(typeof(this.callbacks.channelsLoaded) !== "object") return;

    this.callbacks.channelsLoaded.forEach(function(callback) {
      callback.call();
    });
  }

  convertChannelName(channelName){
    const parts = channelName.split('::');
    return parts.map((part, index) =>
        index === 0 ? part.toLowerCase() : part.charAt(0).toUpperCase() + part.slice(1)
      ).join('');
  }

  convertToChannelObject(subscription){
    let channelName = this.convertChannelName(subscription.channelName());
    return { [channelName]: [subscription] };
  }

  mergeChannelObjects(target, source) {
    for (const key in source) {
      if (target.hasOwnProperty(key)) {
        for (const item of source[key]) {
          if (!target[key].includes(item)) {
            target[key].push(item);
          }
        }
      } else {
        target[key] = source[key];
      }
    }
    return target;
  }
  
  activateChannel(subscription){
    this.activeChannels = this.mergeChannelObjects(this.activeChannels, this.convertToChannelObject(subscription));
    this.subscriptions.push(subscription);
    return this.activeChannels;
  }

  killChannel(subscription){
    let channelKey = this.convertChannelName(subscription.channelName());
    this.activeChannels[channelKey] = this.activeChannels[channelKey]?.filter(existingSubscription => existingSubscription !== subscription);
    return this.subscriptions.pop(subscription);
  }

  trigger(event, timeout=this.options.triggerDelay){
    if(event === "channelsLoaded" && this.channelsIsLoaded) return this;

    var callbacks = this.callbacks[event] || [],
        context   = this,
        args      = arguments;

    clearTimeout(this.options.triggerTimer);

    this.options.triggerTimer = setTimeout(async ()=> {
      this.channelsIsLoaded = true;
      await callbacks.forEach(function(callback) {
        try{
          callback.apply(context, args);
        }catch(e){
          console.warn(e);
        }
      });

      // Active Modal Reposition
      let $activeModal = $("body .ui-dialog[role='dialog']:visible > .ui-dialog-content");
      if(typeof $activeModal.dialog == "function"){
        $activeModal.dialog("option", "position", { my: "center", at: "center", of: window });
      }
    }, timeout || 0);
  }
}
